const Index = () => import('./index.vue');
import List from './components/List.vue'

export default [{
  path: 'merchant',
  name: 'merchant',
  component: Index,
  title: 'merchant',
  redirect: {
    name: 'merchant-list'
  },
  children: [{
      path: 'list',
      name: 'merchant-list',
      component: List,
    },
  ],
}, ]